import React, { useState } from 'react';
import { login } from '../api/authService'; // Función que hace la petición real al backend
import { useNavigate } from 'react-router-dom';
import imagenFondo from '../assets/fondo_index.jpg'; // Imagen de fondo para el Login
import '../styles/HptScreens.css';

// ============================================================================
// COMPONENTE PRINCIPAL: LoginScreen
// ============================================================================
const LoginScreen = () => {
    // --- ESTADOS DEL FORMULARIO ---
    const [usuario, setUsuario] = useState('');     // Nombre de usuario o email
    const [password, setPassword] = useState('');   // Contraseña
    const [error, setError] = useState('');         // Mensaje de error (rojo) si falla
    const [cargando, setCargando] = useState(false);// Para bloquear el botón mientras se valida
    
    const navigate = useNavigate(); // Hook para redireccionar si el login es correcto

    // ============================================================================
    // LÓGICA DE VALIDACIÓN 
    // ============================================================================
    const handleSubmit = async (e) => {
        // Evita que la página web se recargue al pulsar "Entrar"
        e.preventDefault();
        
        setError('');       // Limpiamos errores anteriores
        setCargando(true);  // Desactivamos el botón para evitar doble clic

        try {
            // 1. Enviamos usuario y contraseña al Backend
            const data = await login(usuario, password);

            // 2. Si el backend responde OK, guardamos TOKEN
            localStorage.setItem('userToken', data.token);
                        
            // 3. Redirigimos al panel principal de la aplicación
            navigate('/dashboard');
            
        } catch (err) {
            setError(typeof err === 'string' ? err : "Error al conectar con el servidor");
        } finally {
            setCargando(false);
        }
    };

    // ============================================================================
    // RENDER (HTML/JSX)
    // ============================================================================
    return (
        <div className="login-container" style={{ backgroundImage: `url(${imagenFondo})` }}>
            <div className="login-card">
                <h2 className="login-title">Permisos - Acceso</h2>
                
                <form onSubmit={handleSubmit} className="login-form">
                    {/* Input de Usuario */}
                    <input
                        type="text"
                        placeholder="Usuario"
                        value={usuario}
                        onChange={(e) => setUsuario(e.target.value)}
                        className="login-input"
                        required
                    />
                    
                    {/* Input de Contraseña (texto oculto) */}
                    <input
                        type="password"
                        placeholder="Contraseña"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="login-input"
                        required
                    />
                    
                    {/* Botón de Entrada (Se desactiva y cambia el texto mientras carga) */}
                    <button 
                        type="submit" 
                        className="login-btn"
                        disabled={cargando}
                    >
                        {cargando ? 'Validando...' : 'Entrar al Sistema'}
                    </button>
                </form>
                
                {/* Banner de Error (Solo aparece si el estado 'error' tiene texto) */}
                {error && <p className="login-error">{error}</p>}
            </div>
        </div>
    );
};

export default LoginScreen;